/**
 * Route for `lead-validation-logic-native-no-external-required`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { LeadValidationLogicNativeNoExternalRequiredPage } from "../features/lead-validation-logic-native-no-external-required/LeadValidationLogicNativeNoExternalRequiredPage";

export const leadValidationLogicNativeNoExternalRequiredRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/lead-validation-logic-native-no-external-required",
	component: LeadValidationLogicNativeNoExternalRequiredPage,
});

export default leadValidationLogicNativeNoExternalRequiredRoute;
